"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MARKETING_JOURNEY = exports.MARKETING_CHANNEL = exports.BRANDCODES = void 0;
var MARKETING_JOURNEY = exports.MARKETING_JOURNEY = 'SIGNUP';
var MARKETING_CHANNEL = exports.MARKETING_CHANNEL = 'WEB';
var BRANDCODES = exports.BRANDCODES = ['PINN'];